import { UsuarioFiltro } from './../models/Usuario';
import { ServiceBase,Get } from "./ServiceBase";

const urlBase = `${ServiceBase.instance.defaults.baseURL}usuario/`;

export const BuscaPorUnidadeAtivos=(unidadeId:number)=>{
    return Get<UsuarioFiltro[]>(`${urlBase}unidade/${unidadeId}/ativos`)
}

